import {
  IconTariffBusinessFill,
  IconTariffFranchiseFill,
  IconTariffFreeFill,
  IconTariffGoldFill,
  IconTariffPremiumFill,
  IconTariffSmartFill,
  IconTariffStandartFill,
} from "@packages/icon-library";

export const tariffsInfo = {
  free_c: {
    icon: IconTariffFreeFill,
    color: "neutral",
    checkScan: true,
    offers: true,
    coupons: false,
    services: false,
    referral: false,
    points: "x1",
    bonuses: "",
  },

  smart_c: {
    icon: IconTariffSmartFill,
    color: "red",
    checkScan: true,
    offers: true,
    coupons: true,
    services: true,
    referral: true,
    points: "x2",
    bonuses: 2,
  },

  standard_c: {
    icon: IconTariffStandartFill,
    color: "blue",
    checkScan: true,
    offers: true,
    coupons: true,
    services: true,
    referral: true,
    points: "x4",
    bonuses: 4,
  },

  business_d: {
    icon: IconTariffBusinessFill,
    color: "blue",
  },
  premium_d: {
    icon: IconTariffPremiumFill,
    color: "green",
  },
  vip_d: {
    icon: IconTariffFranchiseFill,
    color: "purple",
  },
  vip_gold_d: {
    icon: IconTariffGoldFill,
    color: "yellow",
  },
};
